import { render } from "./IconCopy.vue?vue&type=template&id=2c05bbc6&scoped=true&ts=true"
import script from "./IconCopy.vue?vue&type=script&lang=ts"
export * from "./IconCopy.vue?vue&type=script&lang=ts"

import "./IconCopy.vue?vue&type=style&index=0&id=2c05bbc6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c05bbc6"]])

export default __exports__